import createModal from './createModal'
import { _ } from '../gettext'

/**
 * Creates alert dialog.
 *
 * @param {string} title
 * @return {Modal}
 */
export default function createAlert (title) {
  const content = `
        <div class="modal-body">${title}</div>
            <div class="modal-footer">
                <a href="#" class="btn btn-primary modal-close">OK</a>
            </div>`

  return createModal(_('Upozornění'), content, true, null)
}
